import TruckSolidIcon from "@core/components/icons/truck-solid";
import BrushSolidIcon from "@core/components/icons/brush-solid";
import CubeSolidIcon from "@core/components/icons/cube-solid";
import FileStackIcon from "@core/components/icons/file-stack";
import CloudTaskIcon from "@core/components/icons/cloud-task";
import ShoppingBagSolidIcon from "@core/components/icons/shopping-bag-solid";
import BulbSolidIcon from "@core/components/icons/bulb-solid";
import ParcelMapIcon from "@core/components/icons/parcel-map";

export const notificationsData = [
  {
    id: 1,
    name: "Invitation for crafting engaging designs",
    icon: BrushSolidIcon,
    unRead: true,
    sendTime: "2023-06-01T09:35:31.820Z",
  },
  {
    id: 2,
    name: "Isomorphic dashboard redesign",
    icon: CubeSolidIcon,
    unRead: true,
    sendTime: "2023-05-30T09:35:31.820Z",
  },
  {
    id: 3,
    name: "3 New Incoming Project Files:",
    icon: FileStackIcon,
    unRead: false,
    sendTime: "2023-06-01T09:35:31.820Z",
  },
  {
    id: 4,
    name: "Swornak purchased isomorphic",
    icon: ShoppingBagSolidIcon,
    unRead: false,
    sendTime: "2023-05-21T09:35:31.820Z",
  },
  {
    id: 5,
    name: "Task #45890 merged with #45890 in “Ads Pro Admin Dashboard project:",
    icon: CloudTaskIcon,
    unRead: true,
    sendTime: "2023-06-01T09:35:31.820Z",
  },
  {
    id: 6,
    name: "3 new application design concepts added",
    icon: BulbSolidIcon,
    unRead: true,
    sendTime: "2023-05-15T09:35:31.820Z",
  },
  {
    id: 7,
    name: "Your order has been placed",
    icon: ParcelMapIcon,
    unRead: false,
    sendTime: "2023-05-16T09:35:31.820Z",
  },
  {
    id: 8,
    name: "Order has been shipped to #123221",
    icon: TruckSolidIcon,
    unRead: false,
    sendTime: "2023-05-01T09:35:31.820Z",
  },
];
